import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsInfo = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <path
          d="M22.4811516,7.5715985V7.5716c-0.5716991-1.354383-1.3929501-2.5703778-2.4365273-3.616225
		C19.0010471,2.911797,17.7850513,2.0905478,16.4284,1.5188484c-1.4020243-0.5921179-2.8925257-0.8938477-4.428401-0.8938477
		s-3.0263748,0.3017298-4.4284,0.8938477C6.2149482,2.0905478,4.9989533,2.911797,3.9553757,3.955375
		S2.0905471,6.2149487,1.5188477,7.5716C0.9267299,8.9736233,0.625,10.4641256,0.625,12s0.3017299,3.0263767,0.8938477,4.4284
		c0.5716994,1.3543835,1.3929501,2.5703773,2.436528,3.6162243c1.0435777,1.0435772,2.2595725,1.8648281,3.6162233,2.4365273
		C8.9736233,23.0732689,10.4641247,23.375,11.999999,23.375s3.0263748-0.3017311,4.428401-0.8938484
		c1.3543816-0.5716991,2.5703773-1.3929501,3.6162243-2.4365273c1.0435772-1.0435791,1.8648281-2.259573,2.4365273-3.6162262
		C23.0732689,15.0263748,23.375,13.5358734,23.375,11.999999S23.0732708,8.9736223,22.4811516,7.5715985z M12.000001,21.8958416
		c-5.4560976,0-9.8958416-4.4397449-9.8958416-9.8958416s4.4397435-9.8958406,9.8958416-9.8958406
		S21.8958416,6.5439029,21.8958416,12S17.4560986,21.8958416,12.000001,21.8958416z"
        />
        <path
          d="M13.125248,5.1668334h0.000001c-0.6034594,0.2699695-0.9709806,0.8938475-0.9119959,1.5540233
		c-0.045373,0.4265056,0.1043568,0.8462057,0.4106245,1.1479354c0.2835808,0.2699695,0.7100859,0.3108048,1.0413094,0.1043587
		c0.4015512-0.2041783,0.6828623-0.5853109,0.7622652-1.0276971C14.7133017,5.8315468,13.9918718,4.8582978,13.125248,5.1668334z"
        />
        <path
          d="M13.7740822,15.1556883c-0.0930138,0.0000029-0.1792269,0.1043625-0.8257875,1.0004721
		c-0.5580864,0.7690735-0.9165335,0.8938484-0.9165335,0.3153439c0-0.1361198,0.3221483-1.3906813,0.7123556-2.7904367
		c0.3902073-1.4020243,0.7441158-2.720109,0.7826834-2.9424362c0.1020889-0.4650726,0.0612535-0.9460268-0.1111641-1.3906803
		c-0.2858496-0.3970137-0.7940264-0.5671625-1.2591-0.4219694c-0.8779669,0.2835808-1.631156,0.8620853-2.1279907,1.6425009
		c-0.4809532,0.6465645-0.6942053,1.0957565-0.6011915,1.270443c0.0294924,0.0635214,0.0884781,0.1088943,0.1542673,0.1225061
		c0.2177916-0.2155218,0.4083567-0.4537296,0.5626249-0.719162c0.1996403-0.303998,0.4219694-0.5966539,0.6647129-0.8711596
		c0.3720589-0.3153429,0.6647139-0.1043587,0.5263271,0.3879385c-0.0317602,0.1293125-0.3652515,1.2432194-0.730505,2.4682894
		c-0.7940264,2.6361685-0.9551001,3.3303747-0.9619055,4.0926409c0,0.4786835,0.0181484,0.5875797,0.1429243,0.7781448
		c0.2858486,0.4673424,0.9119968,0.5217896,1.6606483,0.1542683c1.0254297-0.4991016,2.4909754-2.2573042,2.4297218-2.9038687
		C13.867095,15.2282848,13.8285303,15.1556883,13.7740822,15.1556883z"
        />
        <polygon points="13.7740803,15.1556883 13.7740822,15.1556883 13.7740831,15.1556883 	" />
      </g>
    </SvgIcon>
  );
});

export default AppIconsInfo;
